<template>

</template>

<script>
    export default {
        name: "AppShortcuts"
    }
</script>